import React, { useState } from 'react';
import '../css/SubscriptionModal.css';
import { loadStripe } from '@stripe/stripe-js';
import { useTranslation } from 'react-i18next';


const stripePromise = loadStripe('pk_live_51Q84HxElIS4QMOeNsCJ6FR9HG6QxZ3TnBtiOeOzjT9rL574LDOnppWR67BoIqgelp8811delrYemxGWmRc98vyOF009yXnVdmA');

const selectedUser = JSON.parse(localStorage.getItem("selectedChatUser"));

function SubscriptionModal({ isOpen, onClose }) {
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [step, setStep] = useState(1);
    const { t } = useTranslation();
    const token = localStorage.getItem("authToken");

    const handleChoosePlan = (plan) => {
        setSelectedPlan(plan);
        setStep(2);
    };

    const handleStripePayment = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/subscription/create-subscription-session?plan=${selectedPlan}&userId=${selectedUser?.id}`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = await res.json();
            const stripe = await stripePromise;
            await stripe.redirectToCheckout({ sessionId: data.id });
        } catch (err) {
            console.error("❌ Stripe error:", err);
            alert(t("subscription.errorStripe"));
        }
    };
    const handlePayDunyaPayment = async () => {
        try {
            // Add validation for selectedPlan
            if (!selectedPlan) {
                alert(t("subscription.selectPlanFirst"));
                return;
            }

            const token = localStorage.getItem("authToken");
            if (!token) throw new Error(t("subscription.authError"));

            // Remove plan from body since it's in the URL
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/api/subscription/paydunya/paydunya-session?plan=${encodeURIComponent(selectedPlan)}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        callbackUrl: window.location.origin
                    })
                }
            );

            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.error || t("subscription.paymentFailed"));
            }

            const { redirectUrl } = await response.json();
            if (!redirectUrl) throw new Error(t("subscription.noRedirectUrl"));

            sessionStorage.setItem("pendingPaymentPlan", selectedPlan);
            window.location.href = redirectUrl;

        } catch (error) {
            console.error("Payment error:", error);
            alert(error.message || t("subscription.paymentFailed"));
        }
    };

    return isOpen ? (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                {step === 1 && (
                    <>
                        <h2>{t('subscription.title')}</h2>
                        <div className="plans">
                            <button className="plan-btn" onClick={() => handleChoosePlan("WEEKLY")}>{t('subscription.weekly')}</button>
                            <button className="plan-btn" onClick={() => handleChoosePlan("MONTHLY")}>{t('subscription.monthly')}</button>
                            <button className="plan-btn" onClick={() => handleChoosePlan("ANNUAL")}>{t('subscription.annual')}</button>
                        </div>
                    </>
                )}

                {step === 2 && (
                    <>
                        <h2>{t('subscription.paymentMethod')}</h2>
                        <div className="plans"> {/* ✅ ajoute cette div */}
                            <button className="plan-btn" onClick={handleStripePayment}>
                                {t('subscription.stripe')}
                            </button>
                            <button className="plan-btn" onClick={handlePayDunyaPayment}>
                                {t('subscription.paydunya')}
                            </button>
                        </div>
                    </>
                )}


                <button onClick={onClose} className="close-modal">{t('subscription.close')}</button>

            </div>
        </div>
    ) : null;
}

export default SubscriptionModal;
